import {Component, OnInit, OnDestroy, AfterViewInit, ViewChildren, QueryList} from '@angular/core';
import { DialogsService, NegociosService, NEG_CLASIF, CONFIRMACION_VALUES } from '../../../services';
import { SignalrService } from '../../../signalr/signalR.service';
import { NegocioKanbanCardComponent } from './negocio-kanban-card/negocio-kanban-card.component';
import { ChipsSelectorComponent } from '../../common';
import * as moment from 'moment';
import { ColaboradoresService } from '../../../services';
import { PermisosService, PERM_ACCIONES_ID} from '../../../services/permisos-service';


@Component({
  selector: 'app-negocios-kanban',
  templateUrl: './negocios-kanban.component.html',
  styleUrls: ['./negocios-kanban.component.scss']
})
export class NegociosKanbanComponent implements OnInit, OnDestroy, AfterViewInit {

  private NEG_CLASIF = NEG_CLASIF;
  private CONFIRMACION_VALUES = CONFIRMACION_VALUES;

  private oportPage = 0;
  private compPage = 0;
  private finalPage = 0;

  public estadoFilterOptions = [];

  public oportFilterOpen: boolean = false;
  private oportLoading = false;
  private oportPreviousFilter = [];
  private oportDebounce = false;
  private oportStopScroll = false;

  public compFilterOpen: boolean = false;
  private compLoading = false;
  private compPreviousFilter = [];
  private compDebounce = false;
  private compStopScroll = false;

  private finalLoading = false;
  private finalDebounce = false;
  private finalStopScroll = false;


  public preventOpening = false;

  private signalRSubscriber: any;

  public negocios: any = {
    oportunidades: [],
    comprometidas: [],
    finalizadas: []
  };

  PERM_ACCIONES_ID = PERM_ACCIONES_ID;

  @ViewChildren(NegocioKanbanCardComponent) cardsComponents: QueryList<NegocioKanbanCardComponent>;
  @ViewChildren(ChipsSelectorComponent) chipFilterComponents: QueryList<ChipsSelectorComponent>;
  showKanbanFilters = false;

  constructor(private dialogsService: DialogsService,
              private negociosService: NegociosService,
              private signalRService: SignalrService,
              private permisosService: PermisosService) { }

  ngOnInit() {
    this.estadoFilterOptions = this.negociosService.estadoFilterOptions;
    this.signalRSubscriber = this.signalRService.newNegocioMessage.subscribe(x => this.newSignalRNegocio(x));

    /** Cargamos los valores desde el servicio si los mismos existen para evitar tiempos de carga innecesarios **/
    const allowed = this.negociosService.negocioKanbanLastUpdate !== null ? moment.duration(moment().diff(this.negociosService.negocioKanbanLastUpdate)).asMinutes() < 5 : false;
    if (this.negociosService.negocioKanbanValues.oportunidades !== null && allowed) {
      this.setupOportunidades(this.negociosService.negocioKanbanValues.oportunidades);
    } else {
      this.getOportunidades(true);
    }

    if (this.negociosService.negocioKanbanValues.oportunidades !== null && allowed) {
      this.setupComprometidas(this.negociosService.negocioKanbanValues.comprometidas);
    } else {
      this.getComprometidas(true);
    }

    if (this.negociosService.negocioKanbanValues.oportunidades !== null && allowed) {
      this.setupFinalizadas(this.negociosService.negocioKanbanValues.finalizadas);
    } else {
      this.getFinalizadas(true);
    }

  }

  ngAfterViewInit() {

  }

  newSignalRNegocio(neg: any) {
    if (neg !== null && this.negociosService.negocioKanbanLastSignalRID !== neg.Id) {
      neg['isNew'] = true;
      this.negociosService.negocioKanbanLastSignalRID = neg.Id;
      // verificamos la columna a la que iría
      if (this.estadoFilterOptions.filter(x => x.type === 'o').findIndex(x => x.value === neg.Confirmacion.Estado) > -1) {
        const copy = [...this.negocios.oportunidades];
        const index = copy.findIndex(x => x.Id === neg.Id);
        if (index > -1) {
          copy.splice(index, 1);
        }
        copy.push(neg);
        copy.sort((a, b) => b.Confirmacion.FechaEstado - a.Confirmacion.FechaEstado);
        this.negocios.oportunidades = [...copy];
        this.updateCards();
      } else if (this.estadoFilterOptions.filter(x => x.type === 'c').findIndex(x => x.value === neg.Confirmacion.Estado) > -1) {
        const copy = [...this.negocios.comprometidas];
        const index = copy.findIndex(x => x.Id === neg.Id);
        if (index > -1) {
          copy.splice(index, 1);
        }
        copy.push(neg);
        copy.sort((a, b) => b.Confirmacion.FechaEstado - a.Confirmacion.FechaEstado);
        this.negocios.comprometidas = [...copy];
        this.updateCards();
      } else if (neg.Confirmacion.Estado === CONFIRMACION_VALUES.FINALIZADO) {
        const copy = [...this.negocios.finalizadas];
        const index = copy.findIndex(x => x.Id === neg.Id);
        if (index > -1) {
          copy.splice(index, 1);
        }
        copy.push(neg);
        copy.sort((a, b) => b.Confirmacion.FechaEstado - a.Confirmacion.FechaEstado);
        this.negocios.finalizadas = [...copy];
        this.updateCards();
      }
    }
  }

  ngOnDestroy() {
    if (this.signalRSubscriber) {
      this.signalRSubscriber.unsubscribe();
    }
  }

  loadNegocios() {
    this.searchKanban(null, true);
  }

  onCreateNewNegocio() {
    this.dialogsService.showNewNegocioDialog(null)
      .subscribe(value => {
        if (value) {
          this.loadNegocios();
        }
      });
  }

  closeFilter(e) {
    if (e === 'opo' && this.oportFilterOpen) {
      // solo hacemos una busqueda si el filtro cambió
      if (!this.compareArrays(this.estadoFilterOptions.filter(x => x.type === 'o' && x.active).map(x => x.Id).sort(), this.oportPreviousFilter.sort())) {
        this.searchKanban(e, true);
        this.updateCards();
      }
      this.oportFilterOpen = false;
    } else {
      // solo hacemos una busqueda si el filtro cambió
      if (!this.compareArrays(this.estadoFilterOptions.filter(x => x.type === 'c' && x.active).map(x => x.Id).sort(), this.compPreviousFilter.sort())) {
        this.searchKanban(e, true);
        this.updateCards();
      }
      this.compFilterOpen = false;
    }
    this.preventOpening = true;
    setTimeout(() => {
      this.preventOpening = false;
    }, 105);
  }

  private compareArrays(a, b) {
    if (a.length === b.length) {
      for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  }

  openFilter(e) {
    if (e === 'opo') {
      setTimeout(() => {
        if (!this.preventOpening) {
          this.oportPreviousFilter = this.estadoFilterOptions.filter(x => x.type === 'o' && x.active).map(x => x.Id);
          this.oportFilterOpen = true;
        }
      }, 100);
    } else {
      setTimeout(() => {
        if (!this.preventOpening) {
          this.compPreviousFilter = this.estadoFilterOptions.filter(x => x.type === 'c' && x.active).map(x => x.Id);
          this.compFilterOpen = true;
        }
      }, 100);
    }
  }

  toggleFilter(e) {
    if (e === 'opo') {
      if (this.oportFilterOpen) {
        this.closeFilter('opo');
      } else {
        this.openFilter('opo');
      }
    } else {
      if (this.compFilterOpen) {
        this.closeFilter('');
      } else {
        this.openFilter('');
      }
    }
  }

  fillFilterOptions(type) {
    setTimeout(() => {
      this.chipFilterComponents.forEach(x => {
        if (x.Type === type) {
          const options = this.estadoFilterOptions.filter(y => y.type === type);
          const ids = options.filter(y => y.active).map(y => y.Id);
          x.optionsChange(options.map(y => ({ID: y.Id, ItemLabel: y.label})), ids);
        }
      });
    });
  }

  onColumnFilterChange(type, items) {
    // guardamos los valores en el servicio
    if (items.SelectedIds.length) {
      // recorremos el array de filtros habilitando los que corresponden
      this.estadoFilterOptions.forEach(x => {
        if (x.type === type) {
          x.active = items.SelectedIds.findIndex(y => y === x.Id) > -1;
        }
      });
    } else {
      this.estadoFilterOptions.forEach(x => {
        if (x.type === type) {
          x.active = false;
        }
      });
    }
  }

  public searchKanban(item = null, resetPages) {
    // recibimos null cuando se aplica el filtro general, actualizamos todas las listas
    if (item === null) {
      this.getOportunidades(resetPages);
      this.getComprometidas(resetPages);
      this.getFinalizadas(resetPages);
    } else if (item === 'opo') {
      this.getOportunidades(resetPages);
    } else if (item === '') {
      this.getComprometidas(resetPages);
    }
  }

  getOportunidades (resetPage) {
    this.oportPage = resetPage ? 0 : this.oportPage;
    if (resetPage) {
      this.negocios.oportunidades.splice(0, this.negocios.oportunidades.length);
      this.oportStopScroll = false;
    }
    this.oportLoading = true;
    this.negociosService.getNegocioKanban(NEG_CLASIF.OPORTUNIDADES, this.oportPage)
      .subscribe(res => {
        this.setupOportunidades(res);
        this.negociosService.negocioKanbanValues.oportunidades = this.negocios.oportunidades;
        this.negociosService.negocioKanbanLastUpdate = moment();
      }, err => this.oportLoading = false);
  }

  setupOportunidades(res) {
    if (res) {
      this.negocios.oportunidades = [...this.negocios.oportunidades, ...res];
    }
    if (this.negocios.oportunidades.length) {
      this.oportStopScroll = this.negocios.oportunidades[0].CantidadPaginas - 1 <= this.oportPage;
    } else {
      this.oportStopScroll = true;
    }
    this.oportDebounce = false;
    this.oportPage++;
    this.oportLoading = false;
  }

  getComprometidas (resetPage) {
    this.compPage = resetPage ? 0 : this.compPage;
    if (resetPage) {
      this.negocios.comprometidas.splice(0, this.negocios.comprometidas.length);
    }
    this.compLoading = true;
    this.negociosService.getNegocioKanban(NEG_CLASIF.COMPROMETIDAS, this.compPage)
      .subscribe(res => {
        this.setupComprometidas(res);
        this.negociosService.negocioKanbanValues.comprometidas = this.negocios.comprometidas;
      }, err => this.compLoading = false);
  }

  setupComprometidas(res) {
    if (res) {
      this.negocios.comprometidas = [...this.negocios.comprometidas, ...res];
    }
    if (this.negocios.comprometidas.length) {
      this.compStopScroll = this.negocios.comprometidas[0].CantidadPaginas - 1 <= this.compPage;
    } else {
      this.compStopScroll = true;
    }
    this.compDebounce = false;
    this.compPage++;
    this.compLoading = false;
  }

  getFinalizadas (resetPage) {
    this.finalPage = resetPage ? 0 : this.finalPage;
    if (resetPage) {
      this.negocios.finalizadas.splice(0, this.negocios.finalizadas.length);
    }
    this.finalLoading = true;
    this.negociosService.getNegocioKanban(NEG_CLASIF.FINALIZADAS, this.finalPage)
      .subscribe(res => {
        this.setupFinalizadas(res);
        this.negociosService.negocioKanbanValues.finalizadas = this.negocios.finalizadas;
      }, err => this.finalLoading = false);
  }

  setupFinalizadas(res) {
    if (res) {
      this.negocios.finalizadas = [...this.negocios.finalizadas, ...res];
    }
    if (this.negocios.finalizadas.length) {
      this.finalStopScroll = this.negocios.finalizadas[0].CantidadPaginas - 1 <= this.finalPage;
    } else {
      this.finalStopScroll = true;
    }
    this.finalDebounce = false;
    this.finalPage++;
    this.finalLoading = false;
  }

  getTns(type) {
    if (type === this.NEG_CLASIF.OPORTUNIDADES) {
      return this.negocios.oportunidades.length ? this.negocios.oportunidades[0].IndicadoresTn : 0;
    } else if (type === this.NEG_CLASIF.COMPROMETIDAS) {
      return this.negocios.comprometidas.length ? this.negocios.comprometidas[0].IndicadoresTn : 0;
    } else if (type === this.NEG_CLASIF.FINALIZADAS) {
      return this.negocios.finalizadas.length ? this.negocios.finalizadas[0].IndicadoresTn : 0;
    }
  }

  onScroll(type) {
    switch (type) {
      case NEG_CLASIF.OPORTUNIDADES:
        if (!this.oportDebounce && !this.oportStopScroll ) {
          this.oportDebounce = true;
          this.getOportunidades(false);
        }
        break;
      case NEG_CLASIF.COMPROMETIDAS:
        if (!this.compDebounce && !this.compStopScroll ) {
          this.compDebounce = true;
          this.getComprometidas(false);
        }
        break;
      case NEG_CLASIF.FINALIZADAS:
        if (!this.finalDebounce && !this.finalStopScroll ) {
          this.finalDebounce = true;
          this.getFinalizadas(false);
        }
        break;
    }
  }

  updateCards() {
    if (this.cardsComponents) {
      this.cardsComponents.forEach(x => x.update());
    }
  }

  permisoAutorizado(permisoId) {
    return this.permisosService.permisoAutorizado(permisoId);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-kanban/negocios-kanban.component.ts